<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description:
-->

<template>
  <div class="share-dialog">
    <!-- <div class="dialog-title" >分享</div> -->
    <div v-if="!imgurl" class="content-wrap">
      <div class="content" id="shareCard">
        <div class="share-title">我的减脂日记</div>
        <div class="user-info">
          <div class="header">
            <img v-if="shareData.imgUrl" class="img" :src="shareData.imgUrl" />
            <img v-else class="img" src="../../public/static/images/user.png" />
            <div class="username">{{ shareData.patientName }}</div>
            <div class="sing-time"> {{ shareData.signTime }} </div>
          </div>
          <div class="user-content">
            <div class="item-box">
              <div class="text-box">
                <span class="value"> {{ shareData.loseFatDay }} </span>
                <span class="unit">天</span>
              </div>
              <div class="desc">天数</div>
            </div>
            <div class="line"></div>
            <div class="item-box">
              <div class="text-box">
                <img class="icon" :src="shareData.icon" />
                <span class="value"> {{ shareData.lossWeight || '-' }} </span>
                <span class="unit">kg</span>
              </div>
              <div class="desc">体重</div>
            </div>
          </div>
        </div>
        <div class="info-list">
          <!--  eslint-disable-next-line vue/no-use-v-if-with-v-for -->
          <div v-for="(item, index) in shareList" :key="index" v-if="item.value" class="list-item-box">
            <div v-if="item.type == 'list'" class="list-data-box">
              <div class="title">
                <div class="text">{{ item.text }}</div>
                <div class="value">{{ item.value2 }}</div>
              </div>
              <div>
                <div v-for="(food, i) in item.value || []" :key="i" class="list-data food">
                  <div class="img" v-bind:style="{ backgroundImage: 'url(' + food.img + ')' }"></div>
                  <span class="text"> {{ food.name }} </span>
                  <span class="value"> {{ food.foodQuality || food.sportTime || '-' }} </span>
                  <span class="unit"> {{ food.foodUnit || food.sportUnit }} </span>
                </div>
              </div>

            </div>
            <div v-else class="list-data">
              <span class="text"> {{ item.text }} </span>
              <img v-if="item.icon" class="icon" :src="item.icon" />
              <span class="value"> {{ item.value || '-' }} </span>
              <span class="unit"> {{ item.unit }} </span>
            </div>
          </div>
          <div class="loss-feel">
            <div class="title">减重感受</div>
            <div class="flex">
              <div>饱腹感：{{ shareData.lightMild || '--' }}</div>
              <div>轻松程度：{{ shareData.satiety || '--' }}</div>
            </div>
            <div v-if="shareData.lossFeel" class="desc">{{ shareData.lossFeel }}</div>

          </div>
        </div>
        <div class="saying">
          <div class="say-text"> {{ shareData.saying }} </div>
          <img v-if="shareData.schemeQrUrl" class="img" :src="shareData.schemeQrUrl" />
          <div v-else class="img"></div>
        </div>
      </div>

    </div>
    <div v-else class="img-wrap">
      <div class="tip">
        长按分享或保存图片
      </div>
      <img class="share-img" :src="imgurl" />

    </div>
  </div>
</template>

<script>
import domtoimage from 'dom-to-image';
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import up from '../assets/images/up.jpg';
import down from '../assets/images/down.jpg';
let ketoneList = [{
  text: "未检测",
}, {
  text: "无显示",
}, {
  text: "+",
  color: '#F6A3AD'
}, {
  text: "++",
  color: '#B86884'
}, {
  text: "+++",
  color: '#812752'
}, {
  text: "++++",
  color: '#3F040E'
}]
let lightMildVO = { 1: "非常轻松", 2: "一般", 3: "不轻松" };
let satietyVO = { 1: "很饱", 2: "比较饱", 3: "正好", 4: "比较饿", 5: "很饿" };
let icons = [up, down];
export default {
  data() {
    return {
      imgurl: '',
      shareData: [],
      shareList: [{
        text: '初始体重',
        key: 'initialWeight',
        unit: 'kg'
      }, {
        text: '目标体重',
        key: 'targetWeight',
        unit: 'kg'
      }, {
        text: '今日体重',
        key: 'weight',
        unit: 'kg'
      }, {
        text: '和昨日体重差额',
        key: 'yesterdayLossWeight',
        unit: 'kg'
      }, {
        text: '今日尿酮',
        key: 'type',
      }, {
        text: '今日喝水',
        key: 'waterValue',
        unit: 'ml'
      }, {
        text: '早餐',
        key: 'breakfastList',
        type: 'list',
        valueDesc: '总摄入量：',
        unit: '千卡'
      }, {
        text: '午餐',
        key: 'lunchList',
        type: 'list',

      }, {
        text: '晚餐',
        key: 'dinnerList',
        type: 'list',
      }, {
        text: '加餐',
        key: 'extraMealList',
        type: 'list',
      }, {
        text: '运动',
        key: 'sportEasyVOList',
        type: 'list',
        keys: 'sportInfo',
      }],
      styleobj: {
      }
    };
  },
  mounted() {
    this.getShareData();
    document.title='我的减脂日记'
  },

  created() {
  },
  methods: {
    dealImg(url){
      let url2 = url?url.split("?")?.[0] + `?x-oss-process=image/resize,h_50,m_lfit`:'';
      return url2
    },
    getShareData() {
      const id = getQueryString('id');
      const endTime = getQueryString('endTime');

      // const id = "1877168509061201921";
      // const endTime = "2025-04-09";
      // console.log("endTime",id,endTime)
      ajax
        .Post({
          url: '/api/loss/record/shareByTime',
          data: { "endTime": endTime, "patientId": id }
        }).then(res => {
          if (res.status == 200) {
            let { data } = res.data;
            let list = this.shareList.map(item => {
              if (item.key === 'yesterdayLossWeight') {
                // status 0-下降，1-上升，2-没有变化
                return { ...item, value: data[item.key], icon: icons[data.status] }
              } else if (item.key === 'breakfastList') {
                let value=data[item.key].map(val=>({...val,img:this.dealImg(val.img)}))
                return { ...item, value: [...value], value2: `总摄入量：${data.allFoodEnergy || '-'}千卡`}
              } else if (item.key === 'type') {
                let value = data[item.key] && ketoneList[data[item.key]].text
                return { ...item, value }
              } else if (item.key === 'sportEasyVOList') {
                let value = data[item.key]?.map(it => ({ ...it, img: this.dealImg(it.imgUrl) })) || []
                return { ...item, value, value2: data?.sportInfo || '' };

              } else if ( ['lunchList','dinnerList','extraMealList'].includes(item.key) ){
                let value = data[item.key]?.map(it => ({ ...it, img: this.dealImg(it.img) })) || [];
                return { ...item, value };
              } else {
                return { ...item, value: data[item.key] }
              }

            })

            console.log("list", list)
            let iconStatus = data.lossWeight > 0 ? 1 : 0
            let headerurl=this.dealImg(data?.imgUrl)
            this.shareData = {
              ...data,
              imgUrl: headerurl,
              icon: icons[iconStatus],
              lossWeight: Math.abs(data.lossWeight).toFixed(2),
              lightMild: lightMildVO[data.lightMildCode],
              satiety: satietyVO[data.satietyCode],
              lossFeel: data.lossFeel
            }
            this.styleobj = {
              background: `url(${data.schemeQrUrl})`
            }
            this.shareList = list;
            setTimeout(() => {
                this.domtoimageFn();
            }, 200);
          }
        })

    },
    domtoimageFn() {
      const that = this
      domtoimage.toJpeg(document.getElementById('shareCard'), {
        quality: 1,
        cacheBust: true,

        //  proxy: 'https://static.jk.nutriease.com/'
      })
        .then(function (dataUrl) {
          // console.log("dataUrl", dataUrl);
          that.imgurl = dataUrl
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error);

        });
    }
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.share-dialog {
  width: 100%;
  height: 100%;
  /* padding-top: 160px; */
  position: relative;
  background-color: #EAEDF2;
}

.share-dialog .dialog-title {
  width: 62.5rem;
  height: 10.66rem;
  /* position: fixed; */
  line-height: 10.66rem;
  font-size: 3rem;
  font-weight: 1000;
  color: #333333;
  text-align: center;
  background: #FFFFFF;
  margin-bottom: 2.66rem;
}

.content-wrap {
  width: 200%;
  padding: 2.66rem;
  background: #EAEDF2;
  position: relative;
  transform: scale(0.5) translate(-50%, -50%);
}

.share-title {
  text-align: center;
  font-size: 3rem;
  color: #444;
  padding-bottom: 2rem;
}

.share-img {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  /* position:relative;
  top:1.33rem;
  left:1.33rem; */
}

.share-dialog .content {
  /* width: 47.16rem; */
  width: 100%;
  margin: 0 auto;
  background: #FEDDB5;
  padding: 2.66rem;
}

.share-dialog .content .user-info,
.share-dialog .content .user-list {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 1.34rem;
}

.share-dialog .content .user-info {
  padding: 2.66rem;
  margin-bottom: 2rem;
}

.share-dialog .user-info .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4rem;

}

.share-dialog .user-info .header .img {
  width: 6.66rem;
  height: 6.66rem;
  border-radius: 50%;
  background-color: #ddd;
  margin-right: 1.34rem;
  background-size: 100%;
}

.share-dialog .user-info .header .username {
  flex: 1;
  font-size: 2.8rem;
  font-weight: 400;
  color: #333333;
}

.share-dialog .user-info .header .sing-time {
  font-size: 2.46rem;
  font-weight: 400;
  color: #333333;
}

.user-content {
  display: flex;
  align-items: center;
}

.user-content .item-box {
  flex: 1;
  text-align: center;
}

.user-content .line {
  width: 0.16rem;
  height: 3.66rem;
  background: #D8D8D8;
}

.user-content .item-box .desc {
  font-size: 2rem;
  font-weight: 400;
  color: #999999;
}

.user-content .item-box .text-box {
  height: 5.34rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 0.66rem;
}

.user-content .item-box .text-box .icon {
  width: 2.34rem;
  height: 2.34rem;
}

.item-box .text-box .value {
  font-size: 4.66rem;
  font-weight: bold;
  color: #333333;
  margin-right: 0.66rem;
}

.item-box .text-box .unit {
  font-size: 1.46rem;
  font-weight: 400;
  color: #333333;
}

.content .info-list {
  width: 100%;
  height: auto;
  background-color: #fff;
  border-radius: 1.34rem;
  margin-bottom: 4rem;
}

.info-list .list-data {
  display: flex;
  align-items: center;
  height: 9rem;
  font-size: 2.46rem;
  font-weight: 400;
  color: #333333;
  padding: 0 2.66rem;
  border-bottom: 0.16rem solid #E8E9EC;
}

.info-list .list-data.food {
  border: none;
  height: 6rem;
}

.list-data.food .text {
  font-size: 2.14rem;
  line-height: 2.34rem;
}

.list-data .img {
  width: 4rem;
  height: 4rem;
  margin-right: 1.34rem;
  border-radius: 0.34rem;
  overflow: hidden;
  background-color: #ddd;
  background-size: 100% 100%;
}

.list-data .text {
  flex: 1;
}

.list-data .icon {
  width: 2rem;
  height: 2rem;
}

.list-data-box {
  font-size: 2.14rem;
  font-weight: 400;
  color: #333333;
  padding: 1rem 0;
  border-bottom: 0.16rem solid #E8E9EC;
}

.list-item-box:last-child .list-data-box {
  border: none;
}

.list-data-box .title {
  display: flex;
  justify-content: space-between;
  height: 6.66rem;
  font-size: 2.46rem;
  /* margin-top: 10px; */
  line-height: 6.66rem;
  text-align: left;
  padding: 0 2.66rem;
}

.saying {
  width: 100%;
  max-width: 100%;
  display: flex;
  padding: 2.8rem 2.66rem;
  background: #FFFFFF;
  border-radius: 1.34rem;
}

.saying .say-text {
  flex: 1;
  font-size: 2rem;
  font-weight: 400;
  color: #333333;
  line-height: 3rem;
  margin-right: 2rem;
}

.saying .img {
  width: 8rem;
  height: 8rem;
  background-size: 100% 100%;
}

.tip {
  color: #777;
  color:#FE5B59;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  padding-bottom: 1rem;
}

.img-wrap {
  width: 100%;
  background-color: #EAEDF2;
  padding: 1.3rem;
}

.loss-feel {
  width: 100%;
  padding: 2.66rem;
  color: #333;
  font-size: 2.66rem;
  line-height: 3.66rem;

}

.loss-feel .title {
  margin-bottom: 2rem;

}

.loss-feel .flex {
  display: flex;
  justify-content: space-between;
}
</style>
